import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export function getTimezoneDisplay(
  utcTime: string,
  sessionTZ: string,
  userTZ: string,
): string {
  let userTime = dayjs.utc(utcTime).tz(userTZ).format('h:mm A z')

  if (sessionTZ === userTZ) {
    return userTime
  }

  let sessionTime = dayjs.utc(utcTime).tz(sessionTZ).format('h:mm A z')
  return `${userTime} (${sessionTime})`
}
